import RepositoryFactory from "../../admin/apis/index";
const logs = RepositoryFactory.logs;

export default {
  ApplicationLog({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await logs.ApplicationLog(payload);

        commit("APPLICATION_LOG", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  ErrorLOG({commit}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await logs.ErrorLOG(payload);
        commit("ERROR_LOGS", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
